export const stateName = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chattisgarh",
  "Delhi",
  "Dadra and Nagar Haveli",
  "Goa",
  "Gujarat",
  "Himachal Pradesh",
  "Haryana",
  "Jharkhand",
  "Jammu and Kashmir",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep Islands",
  "Maharashtra",
  "Meghalaya",
  "Manipur",
  "Madhya Pradesh",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Pondicherry",
  "Rajasthan",
  "Sikkim",
  "Telangana",
  "Tamil Nadu",
  "Tripura",
  "Other Territory",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];
export const stateCodes = [
  "AN",
  "AP",
  "AR",
  "AS",
  "BR",
  "CH",
  "CT",
  "DL",
  "DN",
  "GA",
  "GJ",
  "HP",
  "HR",
  "JH",
  "JK",
  "KA",
  "KL",
  "LA",
  "LD",
  "MH",
  "ML",
  "MN",
  "MP",
  "MZ",
  "NL",
  "OR",
  "PB",
  "PY",
  "RJ",
  "SK",
  "TG",
  "TN",
  "TR",
  "TT",
  "UP",
  "UT",
  "WB",
];
